export const GET_DATA = 'GET_DATA';
export const DELETE_DATA = 'DELETE_DATA';
export const CREATE_BOOKMARK = 'CREATE_BOOKMARK';
export const GET_LOAD_MORE = 'GET_LOAD_MORE'
